const AnalyticPageView = (path: string) => {
    window.dataLayer?.push({ event: 'page_view', page_path: path });
};

const CallAnalyticEvent = (path: string, action: string, label?: string) => {
    window.dataLayer?.push({ event: path, action, label });
};

export const Helper = {
    CallAnalyticEvent,
    AnalyticPageView,
}
